import React from 'react';
import { ListSubheader, Typography } from '@mui/material';
import type { AssuntoStructuredOption } from '../../utils/assuntoDisplay';
import { formatAssuntoLabel } from '../../utils/assuntoDisplay';

interface Props {
  option: Pick<AssuntoStructuredOption, 'agenda' | 'tema'>;
  /** Texto compacto sem quebra (input selecionado). */
  inline?: boolean;
}

export function AssuntoOptionLabel({ option, inline = false }: Props) {
  const tema = (option.tema || '').trim();

  // Chip selecionado no input (fora do grupo): mostra agenda + tema.
  if (inline) {
    return (
      <Typography component="span" variant="body2" sx={{ fontWeight: 400 }}>
        {option.agenda}
        {tema && (
          <Typography component="span" variant="body2" color="text.secondary" sx={{ fontWeight: 400 }}>
            {' '}({tema})
          </Typography>
        )}
      </Typography>
    );
  }

  // No dropdown a agenda JÁ é o cabeçalho do grupo — a opção mostra só o tema,
  // senão a agenda aparecia duplicada (uma no cabeçalho, outra em cada item).
  // Sem tema = a própria agenda é a opção (seleção da agenda inteira).
  return (
    <Typography component="span" variant="body2" sx={{ fontWeight: 400 }}>
      {tema || option.agenda}
    </Typography>
  );
}

/** Cabeçalho de grupo (assunto-mãe) no dropdown. */
export function AssuntoGroupHeader({ label }: { label: string }) {
  return (
    <ListSubheader
      component="div"
      disableSticky
      sx={{
        fontWeight: 700,
        fontSize: '0.8125rem',
        lineHeight: '32px',
        color: 'text.primary',
        bgcolor: 'background.paper',
      }}
    >
      {label}
    </ListSubheader>
  );
}

export function assuntoOptionText(option: Pick<AssuntoStructuredOption, 'agenda' | 'tema'>): string {
  return formatAssuntoLabel(option);
}
